import request from '../util/request'
// 根据id查询账户信息
export function getUserInfo (id) {
  return request({
    url: '/accounts/selectAccountById?id=' + id,
    method: 'post'
  })
}

// 根据条件查询账户列表
// {
//   "accountType": 0,
//   "companyAccount": "string",
//   "companyName": "string",
//   "createTime": "2023-03-28T05:45:55.684Z",
//   "email": "string",
//   "id": "string",
//   "licenceEffectiveTime": 0,
//   "licenseEndTime": "2023-03-28T05:45:55.684Z",
//   "licenseId": "string",
//   "licenseStartTime": "2023-03-28T05:45:55.684Z",
//   "licenseType": 0,
//   "machineCode": "string",
//   "password": "string",
//   "serverAddress": "string",
//   "telephone": "string",
//   "usedUserCount": 0,
//   "userCount": 0,
//   "userGroup": 0,
//   "userName": "string",
//   "uuid": "string",
//   "versionInfo": "string"
// }
export function getAllUserList (data) {
  return request({
    url: '/accounts/selectByCondition',
    data,
    method: 'post'
  })
}

// 用户登录
export function userLogin (data) {
  return request({
    url: '/login/accountsLogin',
    data: data,
    method: 'post'
  })
}
// dsim管理员退出
export function dsimLogout (data) {
  return request({
    url: '/login/accountsLogout',
    data: data,
    method: 'post'
  })
}
// 新增修改用户
export function addOrUpdateAccounts (data) {
  return request({
    url: '/accounts/addOrUpdateAccounts',
    data: data,
    method: 'post'
  })
}
// 根据id删除用户信息
export function deleteAccounts (id) {
  return request({
    url: '/accounts/deleteAccounts?id=' + id,
    method: 'post'
  })
}
// 修改账户密码
export function updatePassword (data, password) {
  return request({
    url: '/accounts/updatePassword?password=' + password,
    data,
    method: 'post'
  })
}

// 新增或修改计算机
export function addOrUpdateComputer (data) {
  return request({
    url: '/computerList/addOrUpdateComputer',
    data,
    method: 'post'
  })
}
// id删除计算机
export function deleteComputerById (id) {
  return request({
    url: '/computerList/deleteComputerById?id=' + id,
    method: 'post'
  })
}
// 条件查询计算机列表
export function selectComputerListByCondition (data) {
  return request({
    url: '/computerList/selectComputerListByCondition',
    data,
    method: 'post'
  })
}

// 新增或修改子账户
export function addOrUpdateSubUser (data) {
  return request({
    url: '/subUser/addOrUpdateSubUser',
    data,
    method: 'post'
  })
}
// id删除子账户
export function deleteSubUserById (id) {
  return request({
    url: '/subUser/deleteSubUserById?id=' + id,
    method: 'post'
  })
}
// 条件查询子账户
export function selectSubUserByCondition (data) {
  return request({
    url: '/subUser/selectSubUserByCondition',
    data,
    method: 'post'
  })
}
// id查询子账户
export function selectSubUserById (id) {
  return request({
    url: '/subUser/selectSubUserById?id=' + id,
    method: 'post'
  })
}
// 获取simClient激活数量
export function getAccountsActiveNum(id) {
  return request({
    url: '/accounts/selectAccountsActiveNumById?id=' + id,
    method: 'post'
  })
}
// 获取simClient在线用户数
export function getAccountsOnlineNum (id) {
  return request({
    url: '/accounts/selectAccountsOnlineNumById?id=' + id,
    method: 'post'
  })
}
// 获取computer的激活数量/已用许可证数
export function getComputerNumber (id) {
  return request({
    url: '/subUser/selectSubUserActiveNumById?id=' + id,
    method: 'post'
  })
}
// 获取computer的在线用户数
export function getSubUserOnlineNum (id) {
  return request({
    url: '/subUser/selectSubUserOnlineNumById?id=' + id,
    method: 'post'
  })
}

// 登录信息查看 type1外侧登录信息 2管理界面登录信息 3活动信息
export function getShowComputerList (id, type, pageNum, pageSize) {
  return request({
    url: `/login/getLoginInfos?userId=${id}&type=${type}&pageNum=${pageNum}&pageSize=${pageSize}`,
    method: 'post'
  })
}

// 注册联网个人版账号
export function addOnlinePersionAccounts (data, lang) {
  return request({
    url: '/accounts/addOnlinePersionAccounts?lang=' + lang,
    data,
    method: 'post'
  })
}
// 联网个人版账号 重置密码
export function resetPassword (data) {
  return request({
    url: '/accounts/resetPersonPassword',
    data,
    method: 'post'
  })
}
// 联网个人版账号 验证邮箱是否存在
export function validateEmail (email) {
  return request({
    url: '/accounts/getIsHaveEmail?email=' + email,
    method: 'post'
  })
}
// 联网个人版账号 发送邮箱验证码
export function sendEmailSecurityCode (email, lang) {
  return request({
    url: '/accounts/sendEmailSecurityCode?email=' + email + '&lang=' + lang,
    method: 'post'
  })
}
// 重新发送邮箱验证码
export function sendEmailActiveCode (email, lang) {
  return request({
    url: '/accounts/sendEmailActiveCode?email=' + email + '&lang=' + lang,
    method: 'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/javaApi.js